<div class="common-layout {{ 'is-' + selectedHeaderColor }}" 
    [ngClass]="{
        'is-folded': isFolded,
        'is-side-nav-dark' : isSideNavDark,
        'is-expand' : isExpand
    }"
>
    <app-header></app-header>
    <app-sidenav></app-sidenav>
    <div class="page-container">
        <div class="main-content">
            <div class="main-content-header" *ngIf="contentHeaderDisplay !== 'none'">
                <h4 style="font-weight: 600" class="page-title" *ngIf="breadcrumbs$ | async; let breadcrumbs">{{(breadcrumbs[breadcrumbs.length - 1].label)}}</h4>
            <div style="float:right;text-align:right;width:100%;">
                <!-- <nz-breadcrumb nzSeparator=">">
                    <i class="m-r-5 text-gray" nz-icon nzType="home"></i>
                    <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs$ | async">
                         <a [routerLink]="breadcrumb.url">
                            {{ breadcrumb.label }}
                        </a>
                    </nz-breadcrumb-item>
                </nz-breadcrumb> -->
            </div>
            </div>
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
</div>

<!-- <div class="common-layout {{ 'is-' + selectedHeaderColor }}" [ngClass]="{
    'is-folded': isFolded,
    'is-side-nav-dark' : isSideNavDark,
    'is-expand' : isExpand
}">
<app-header></app-header>
<app-sidenav></app-sidenav>
<div class="page-container">
    <div class="main-content">
        <div class="main-content-header" *ngIf="contentHeaderDisplay !== 'none'">
            <h4 class="page-title f-600 font-small-caps" *ngIf="breadcrumbs$ | async; let breadcrumbs" style="width: 250px">
                {{(breadcrumbs[breadcrumbs.length - 1].label)}}</h4>
            <div style="float:right;text-align:right;width:100%;">
                <nz-breadcrumb nzSeparator=">" style="font-size: 14px;">
                    <i class="m-r-5 text-gray" nz-icon nzType="home"></i>
                    <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs$ | async">
                        {{breadcrumb | json }}
                        <a [routerLink]="breadcrumb.url" class="font-small-caps">
                            {{ breadcrumb.label }}
                        </a>
                    </nz-breadcrumb-item>
                </nz-breadcrumb>
                </div>
        </div>
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>
</div> -->